import React, { useState, useEffect } from "react";
import { get, post } from "../../../services/api";
import { toast } from "react-toastify";

function PublishPosition() {
  const token = localStorage.getItem("token");

  const [departments, setDepartments] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [formData, setFormData] = useState({
    positionTitle: "",
    departmentId: "",
    campusId: "",
    jobDescription: "",
    requirements: "",
    postedDate: new Date().toISOString().split("T")[0],
    closingDate: "",
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const organizationId = localStorage.getItem("organizationId");

  useEffect(() => {
    fetchMasterData();
  }, []);

  const fetchMasterData = async () => {
    try {
      const [deptResponse, campusResponse] = await Promise.all([
        get(
          `Configuration/departments?organizationId=${organizationId}&CenterId=${savedCenterId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        ),
        get(
          `Configuration/campuses?organizationId=${organizationId}&CenterId=${savedCenterId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        ),
      ]);
      console.log("depart", deptResponse.data);
      setDepartments(deptResponse.data || []);
      setCampuses(campusResponse.data || []);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handlePublish = async () => {
    if (
      !formData.positionTitle ||
      !formData.departmentId ||
      !formData.closingDate ||
      !formData.jobDescription
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      console.log(
        "PUBLISH DATA",
        JSON.stringify({
          organizationId: 1,
          positionTitle: formData.positionTitle,
          departmentId: parseInt(formData.departmentId),
          campusId: formData.campusId ? parseInt(formData.campusId) : null,
          jobDescription: formData.jobDescription,
          requirements: formData.requirements,

          closingDate: formData.closingDate,
        }),
      );
      const response = await post(
        "Onboarding/job-posting",
        {
          organizationId: organizationId,
          centerId: savedCenterId,
          positionTitle: formData.positionTitle,
          departmentId: parseInt(formData.departmentId),
          jobDescription: formData.jobDescription,
          requirements: formData.requirements,
          postedDate: formData.postedDate,
          closingDate: formData.closingDate,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.success) {
        setShowSuccess(true);
        toast.success("Position published successfully!");
        setTimeout(() => setShowSuccess(false), 3000);
        handleReset();
      }
    } catch (error) {
      console.error("Error publishing position:", error);
      toast.error(
        error.response?.data?.message || "Failed to publish position",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      positionTitle: "",
      departmentId: "",
      campusId: "",
      jobDescription: "",
      requirements: "",
      postedDate: new Date().toISOString().split("T")[0],
      closingDate: "",
    });
    setShowSuccess(false);
  };

  return (
    <div className="row g-3">
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Publish Position</h4>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="mb-3 fs-9 border-bottom pb-2">
              Job Posting Details
            </h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">
                  Position Title<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="e.g., Senior Accountant"
                  value={formData.positionTitle}
                  onChange={(e) =>
                    handleChange("positionTitle", e.target.value)
                  }
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Department<span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={formData.departmentId}
                  onChange={(e) => handleChange("departmentId", e.target.value)}
                >
                  <option value="">-- Select Department --</option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.departmentName || dept.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Posted Date<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={formData.postedDate}
                  onChange={(e) => handleChange("postedDate", e.target.value)}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Application Deadline<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={formData.closingDate}
                  onChange={(e) => handleChange("closingDate", e.target.value)}
                />
              </div>

              <div className="col-12">
                <label className="form-label">
                  Job Description<span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Detailed job description..."
                  value={formData.jobDescription}
                  onChange={(e) =>
                    handleChange("jobDescription", e.target.value)
                  }
                />
              </div>

              <div className="col-12">
                <label className="form-label">Requirements</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Education, experience, skills required..."
                  value={formData.requirements}
                  onChange={(e) => handleChange("requirements", e.target.value)}
                />
              </div>
            </div>

            <div className="mt-4 d-flex gap-2">
              <button
                type="button"
                className="btn btn-success"
                onClick={handlePublish}
                disabled={loading}
              >
                <i className="fas fa-check me-1"></i>
                {loading ? "Publishing..." : "Publish Position"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleReset}
              >
                <i className="fas fa-redo me-1"></i>
                Reset
              </button>
            </div>

            {showSuccess && (
              <div className="alert alert-success mt-3">
                <i className="fas fa-check-circle me-2"></i>
                Position published successfully! Applicants can now apply.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublishPosition;
